// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__BBzbA","signatureBlock":"Footer_signatureBlock__2imGN","signature":"Footer_signature__1jM5u"};